import { useState, useContext, createContext } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [authed, setAuthed] = useState(false);
  const [Nombre, setNombre] = useState("");
  const [Rol, setRol] = useState("");
  const [UID, setUID] = useState("");
  const [DiasAntes, setDiasAntes] = useState("");
  const [DiasDespues, setDiasDespues] = useState("");
  const [HoraInicio, setHoraInicio] = useState("");
  const [HoraFin, setHoraFin] = useState("");
  const [UvieID, setUvieID] = useState("");

  const login = (user) => {
    setNombre(user.Nombre + " " + user.Apellido);
    setRol(user.Rol);
    setUID(user.UsuarioID);
    setDiasAntes(user.DiasAntes);
    setDiasDespues(user.DiasDespues);
    setHoraInicio(user.HoraInicio);
    setHoraFin(user.HoraFin);
    setUvieID(user.UvieID);
    setAuthed(true);
  };

  const logout = () => {
    setAuthed(false);
  };

  return <AuthContext.Provider value={{ authed, Nombre, Rol, UID, DiasAntes, DiasDespues, HoraInicio, HoraFin, UvieID, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
